
import { defineComponent, ref, reactive, toRefs, onMounted, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      pagination1: {
        showSizeChanger: true,
        showTotal: (total: any) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showQuickJumper: true
      },
      data: [],
      columns: [],
      spinning: true,
      pagination: false
    })
    pageData.columns = [
      {
        title: '解禁时间',
        dataIndex: 'time',
        key: 'time',
        width: '100px'
      },
      {
        title: '解禁数量(股)',
        dataIndex: 'Num',
        key: 'Num',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占总股本比例',
        dataIndex: 'ShareCapitalPercentage',
        key: 'ShareCapitalPercentage',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '占总流通股本比例',
        dataIndex: 'CirculationPercentage',
        key: 'CirculationPercentage',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '股票类型',
        dataIndex: 'StockType',
        key: 'StockType',
        width: '200px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      }
    ]
    watch(
      () => ((props || {}).pageSourceData || {}).SaleRestrictionData || [],
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val))
        if (data.length > 10) {
          pageData.pagination = pageData.pagination1
        } else {
          pageData.pagination = false
        }
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'SaleRestrictionData' + i
            item.time = item.TradeDay ? window.moment(item.TradeDay * 1000).format('YYYY-MM-DD') : '—'
            item.Num = item.Num * 10000
          })
        }
        pageData.data = data
        pageData.spinning = false
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
